import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { FundDetailWithAggregates } from "./types";

// GET /api/admin/mdf/funds/:id → FundDetailWithAggregates
//
// Sub-bucket 15 — fund-detail page. Carries the fund + every allocation
// (with used / balance computed server-side) + the total request count for
// the requests-tab badge. Phase 6 mutation hooks (allocation CRUD, fund
// update/close) already invalidate `queryKeys.mdf.fund(id)` so the detail
// page refreshes after any write.
export function useFund(id: string) {
  return useQuery<FundDetailWithAggregates, ApiClientError>({
    queryKey: queryKeys.mdf.fund(id),
    queryFn: () => apiFetch<FundDetailWithAggregates>(`/admin/mdf/funds/${id}`),
    enabled: !!id,
  });
}
